<template>
  <span class="Title1 crimson center redemption-code">{{ code }}</span>
</template>

<script>
  export default {
    name: 'redemption-code',
    props: {
      code: {type: String, required: true},
    },
  }
</script>

<style lang="scss">
  .redemption-code {
    letter-spacing: 2px;
  }
</style>
